import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearPermiso } from "../hooks/use-permisos-mutations";

const CODIGO_RE = /^[a-z0-9_]+(\.[a-z0-9_]+)+$/;

/**
 * Formulario de alta de un permiso PERSONALIZADO · código (grupo.accion) +
 * grupo + descripción. Nace «pendiente de cablear»: no otorga acceso hasta que
 * un desarrollador lo conecte con un `.RequirePermiso` en el código.
 */
export function PermisoCrearForm({ onSalir }: { onSalir: () => void }) {
  const [codigo, setCodigo] = useState("");
  const [grupo, setGrupo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const crear = useCrearPermiso({ onCreado: onSalir });

  const submit = () => {
    const c = codigo.trim().toLowerCase();
    if (!c || !grupo.trim() || !descripcion.trim()) {
      toastError({ title: "Datos incompletos", message: "Código, grupo y descripción son obligatorios." });
      return;
    }
    if (!CODIGO_RE.test(c)) {
      toastError({ title: "Código inválido", message: "Formato «grupo.accion» en minúsculas (ej. reportes.exportar)." });
      return;
    }
    crear.mutate({ codigo: c, grupo: grupo.trim(), descripcion: descripcion.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nuevo permiso"
      descripcion="El código va en formato «grupo.accion» (minúsculas). El permiso queda registrado y asignable a roles, pero NO otorga acceso hasta que un desarrollador lo cablee en el código (endpoints/pantallas)."
      cols={2}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input
        label="Código"
        placeholder="Ej. reportes.exportar"
        value={codigo}
        onChange={(e) => setCodigo(e.currentTarget.value.toLowerCase())}
        maxLength={80}
        required
      />
      <Input label="Grupo" placeholder="Ej. Reportería" value={grupo} onChange={(e) => setGrupo(e.currentTarget.value)} maxLength={60} required />
      <Input
        label="Descripción"
        placeholder="¿Qué habilita este permiso?"
        value={descripcion}
        onChange={(e) => setDescripcion(e.currentTarget.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        maxLength={300}
        required
        wrapperClassName="col-span-2"
      />
    </CrearEntidadForm>
  );
}
